import { BaseRequest } from '@/network/requests/BaseRequest'
import { defect_xxx } from '@/interfaces/defect_xxx'

/**
 * 获取缺陷信息请求对象
 * @param defectBatchId 批次id，即 defect_statis 的id，这里改为 batchId 是方便语义理解
 */
export const getDefectRequest = (defectBatchId: string) => BaseRequest.build<defect_xxx>(`defect_${defectBatchId}`)

/**
 * 获取缺陷图片。
 * @param md5
 * @param defectBatchId
 */
export const getDefectImageUrlByMd5 = async (md5: string, defectBatchId: string) => {
	var request = BaseRequest.build<defect_xxx>(`defect_${defectBatchId}`)
	var imgSrc = ''
	try {
		var content = await request.getFileContentById(md5, { responseType: 'arraybuffer' })
		var data = content.data

		imgSrc = 'data:image/png;base64,' + btoa(new Uint8Array(data).reduce((data, byte) => data + String.fromCharCode(byte), ''))
	} catch (error) {}

	return imgSrc
}

export const getDefectTypeGroup = defectBatchId => {
	console.log('创建聚合统计')
	var request = getDefectRequest(defectBatchId)
	var result: any
	try {
		result = request.aggregateQuery('type-stat', null)
	} catch (ex) {
		// await request.putObject({
		// 	aggrs: [
		// 		{
		// 			stages: [
		// 				{
		// 					$group: {
		// 						_id: '$type_index',
		// 						count: {
		// 							$sum: 1,
		// 						},
		// 					},
		// 				},
		// 			],
		// 			type: 'pipeline',
		// 			uri: 'type-stat',
		// 		},
		// 	],
		// })
		//result = request.aggregateQuery('type-stat', undefined)
	}

	return result
}
